import blog1 from '@/assets/img/shortcode/blog/blog-01.jpg'
import blog2 from '@/assets/img/shortcode/blog/blog-02.jpg'
import blog3 from '@/assets/img/shortcode/blog/blog-03.jpg'
import blog4 from '@/assets/img/shortcode/blog/blog-14.jpg'
import blog5 from '@/assets/img/shortcode/blog/blog-15.jpg'
import blog6 from '@/assets/img/shortcode/blog/blog-16.jpg'
import blog7 from '@/assets/img/shortcode/blog/blog-17.jpg'
import blog8 from '@/assets/img/shortcode/blog/blog-18.jpg'
import blog9 from '@/assets/img/shortcode/blog/blog-19.jpg'
import blog10 from '@/assets/img/shortcode/blog/blog-20.jpg'

import post1 from '@/assets/img/blog-details/post-01.jpg'
import post2 from '@/assets/img/blog-details/post-02.jpg'

import team1 from '@/assets/img/testimonial/tmnl-01.jpg'
import team2 from '@/assets/img/testimonial/tmnl-02.jpg'
import team3 from '@/assets/img/testimonial/tmnl-03.jpg'


export const blogOneData = [
    {
        id:1,
        image:blog1,
        date:'13th Sept 2025',
        tag:'Interior',
        title:'Auctor sit elementum habitant vel tempor varius.',
        desc:'Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . . '
    },
    {
        id:2,
        image:blog2,
        date:'29th Nov 2025',
        tag:'Chair',
        title:'Consectetur purus habitasse ut diam habitant varius.',
        desc:'Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . . '
    },
    {
        id:3,
        image:blog3,
        date:'29th Dec 2025',
        tag:'Vase',
        title:'Far far away of furniture of this habitant vel tempor.',
        desc:'Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . . '
    },
    {
        id:4,
        image:blog4,
        date:'13th March 2025',
        tag:'Interior',
        title:'Good Ideas to Update your Living Room.',
        desc:'Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . . '
    },
    {
        id:5,
        image:blog5,
        date:'5th May 2025',
        tag:'Vase',
        title:'Tips and Tricks to Avoid the Stress of Clutter.',
        desc:'Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . . '
    },
    {
        id:6,
        image:blog6,
        date:'19th June 2025',
        tag:'Sofa',
        title:`Name Brand Children's Bedroom Furniture Built to Last.`,
        desc:'Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . . '
    },
    {
        id:7,
        image:blog7,
        date:'20th June 2025',
        tag:'Chair',
        title:'Consectetur purus habitasse ut diam habitant varius.',
        desc:'Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . . '
    },
    {
        id:8,
        image:blog8,
        date:'31th Aug 2025',
        tag:'Vase',
        title:'Far far away of furniture of this habitant vel tempor.',
        desc:'Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . . '
    },
    {
        id:9,
        image:blog9,
        date:'1st Sept 2025',
        tag:'Interior',
        title:'How to Make a Small Bedroom Look Bigger.',
        desc:'Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . . '
    },
    {
        id:10,
        image:blog10,
        date:'13th Sept 2025',
        tag:'Vase',
        title:'6 Tips to Warm Up Your Gray and White Decor.',
        desc:'Nibh purus integer elementum in. ipsuim for now dolor sit amet of this conqure varius . . . '
    },
]

export const blogTag = [
    'Chair',
    'Art & Paint',
    'Mirror',
    'Table',
    'Lam'
]

export const recentPost = [
    {
        name:'PREV POST',
        image:post1,
        date:'19th June 2025',
        tag:'Interior',
        title:'Consectetur purus habitasse ut diam habitant varius.'
    },
    {
        name:'NEXT POST',
        image:post2,
        date:'20th June 2025',
        tag:'Vases',
        title:'Far far away of furniture of this habitant vel tempor.'
    },
]

export const comments = [
    {
        image:team1,
        name:'Michele Obama',
        decs:`Adipiscing lobortis interdum fringilla odio vitae nam pulvinar elementum. Nibh purus this integer. Auctor sit tempor varius.`
    },
    {
        image:team2,
        name:'John Smith Doe',
        decs:`Adipiscing lobortis interdum fringilla odio vitae nam pulvinar elementum. Nibh purus this integer. Auctor sit tempor varius.`
    },
    {
        image:team3,
        name:'Max Franklline',
        decs:`Adipiscing lobortis interdum fringilla odio vitae nam pulvinar elementum. Nibh purus this integer. Auctor sit tempor varius.`
    },
]

export const blogCategory = [
    'Chair',
    'Table',
    'Sofa Set',
    'Lamp',
    'Vases',
    'Mirror',
    'Art & Design'
]

export const recentPostTwo = [
    'Auctor sit elementum habitant vel tempor varius.',
    'Consectetur purus habitasse ut diam habitant varius.',
    'Auctor sit elementum habitant vel tempor varius.',
    'Far far away of furniture of this habitant vel tempor.',
]

export const popularTag = [
    'Interior',
    'Art & Paint',
    'Mirror',
    'Table',
    'Lamp',
    'Vases',
    'Sofa Set',
    'Mirror',
    'Airt & Design',
    'Valuput',
]